import { IncomingOptionsRequest } from "../messages/methods/options";
import { IncomingRequestDelegate } from "../messages/incoming-request";
import { IncomingRequestMessage } from "../messages/incoming-request-message";
import { NonInviteServerTransaction } from "../transactions/non-invite-server-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentServer } from "./user-agent-server";

/**
 * OPTIONS UAS.
 * @public
 */
export class OptionsUserAgentServer extends UserAgentServer implements IncomingOptionsRequest {
  constructor(core: UserAgentCore, message: IncomingRequestMessage, delegate?: IncomingRequestDelegate) {
    super(NonInviteServerTransaction, core, message, delegate);
  }
}
